module.exports = __webpack_public_path__ + "static/media/mnf-search.03b805d1.png";